<template>
  <DataTable
    :value="accesosInforme"
    :loading="loading"
    loading-icon="pi pi-spin pi-spinner"
    scrollable
    :scrollHeight="totalHeight"
  >
    <template #empty>
      <div class="p-text-center">
        <span class="p-text-bold">No hay accesos</span>
      </div>
    </template>
    <Column header="Nombre">
      <template #body="slotProps">
        <div class="white-space-nowrap">
          {{ slotProps.data.nombre }}
        </div>
      </template>
    </Column>
    <Column header="Email">
      <template #body="slotProps">
        <div class="white-space-nowrap">
          {{ slotProps.data.email }}
        </div>
      </template>
    </Column>
    <Column header="Acceso">
      <template #body="slotProps">
        <div class="white-space-nowrap">
          {{ formatDate(convertUtcToLocalTime(slotProps.data.fechaAcceso)) }}
          {{ formatTime(convertUtcToLocalTime(slotProps.data.fechaAcceso)) }}
        </div>
      </template>
    </Column>
    <Column v-if="userRol == 'Admin'" header="Impersonado">
      <template #body="slotProps">
        <div v-if="slotProps.data.impersonado">
          {{ slotProps.data.impersonadoPor }}
        </div>
        <div v-else>
          <span class="text-gray-400">No</span>
        </div>
      </template>
    </Column>
  </DataTable>
  <Paginator
    :rows="rows"
    :totalRecords="totalResults"
    :rowsPerPageOptions="rowsPerPageOptions"
    @page="onPage"
  ></Paginator>
</template>

<script setup>
import { nextTick, onMounted, ref } from "vue";
import DataTable from "primevue/datatable";
import Paginator from "primevue/paginator";
import Column from "primevue/column";
import { useAuthorization } from "@sttedra_ui/framework";

import {
  formatDate,
  formatTime,
  convertUtcToLocalTime,
} from "@/composables/_commons/helper.js";
import { userReportUserAccess } from "@/api/reports/reports.api";

// #region Props, Emits
const props = defineProps({
  informe: {
    type: Array,
    required: true,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const { modelRef: authorizationModelRef } = useAuthorization();
const userRol = authorizationModelRef.value.roles[0];
const loading = ref(false);
const accesosInforme = ref([]);
const rows = ref(10);
const rowsPerPageOptions = ref([10, 20, 50]);
const totalResults = ref(0);
const totalHeight = ref("0px");
// #endregion

// #region Functions
async function setTableHeight() {
  const reportHasUsersDialog = document.querySelector(
    ".report-has-users-dialog"
  );

  if (reportHasUsersDialog) {
    await nextTick();

    const dialogHeader = reportHasUsersDialog.querySelector(".p-dialog-header");
    const tabViewNav = reportHasUsersDialog.querySelector(
      ".p-tabview-nav-container"
    );
    const datatableTHead =
      reportHasUsersDialog.querySelector(".p-datatable-thead");
    const paginatorWrapper = reportHasUsersDialog.querySelector(".p-paginator");

    const reportHasUsersDialogHeight = reportHasUsersDialog
      ? reportHasUsersDialog.clientHeight
      : 0;
    const dialogHeaderHeight = dialogHeader ? dialogHeader.clientHeight : 0;
    const tabViewNavHeight = tabViewNav ? tabViewNav.clientHeight : 0;
    const datatableTHeadHeight = datatableTHead
      ? datatableTHead.clientHeight
      : 0;
    const paginatorWrapperHeight = paginatorWrapper
      ? paginatorWrapper.clientHeight
      : 0;

    const maxTableHeight =
      reportHasUsersDialogHeight -
      dialogHeaderHeight -
      tabViewNavHeight -
      datatableTHeadHeight -
      paginatorWrapperHeight;

    totalHeight.value = `calc(${maxTableHeight}px - 5px - 1.25rem  * 2)`;
  }
}

onMounted(() => {
  onPage();
  setTableHeight();
  window.addEventListener("resize", setTableHeight);
});

async function onPage(event = null) {
  const timeout = setTimeout(() => {
    loading.value = true;
  }, 1000);

  rows.value = event ? event.rows : rows.value;

  const access = await userReportUserAccess({
    alias: props.informe.alias,
    pageIndex: event ? event.page + 1 : 1,
    pageSize: event ? event.rows : rows.value,
  });

  clearTimeout(timeout);

  accesosInforme.value = access.data;
  totalResults.value = access.totalResults;

  loading.value = false;
}
// #endregion

// #region Provide, Expose
// #endregion
</script>
